// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3xORx","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__jqH-W"};